import { FiAlignLeft, FiHash } from "react-icons/fi";
import CrudTemplate from "../crudTemplate";
import FilialService from "../../services/resource/filialService";
import EstadoService from "../../services/resource/estadoService";
import CidadeService from "../../services/resource/cidadeService";
import { useEffect, useState } from "react";

export default function FilialCrud() {
    const service = new FilialService();
    const estadoService = new EstadoService();
    const cidadeService = new CidadeService();

    const [cidades, setCidades] = useState([]);
    const [estados, setEstados] = useState([]);

    useEffect(() => {
        estadoService.listar().then(res => setEstados(res.data)).catch(e => console.error(e));
        cidadeService.listar().then(res => setCidades(res.data)).catch(e => console.error(e));
    }, []);

    const formFields = [
        { name: "id", label: "ID", type: "input", disabled: true, typeText: "number", colSpan: 1, icon: <FiAlignLeft className="text-muted-foreground" /> },
        { name: "nome", label: "Nome", type: "input", colSpan: 1, icon: <FiHash className="text-muted-foreground" /> },
        { name: "codigo", label: "Código", type: "input", typeText: "number", colSpan: 1, icon: <FiAlignLeft className="text-muted-foreground" /> },
        {
            name: "tipoDistribuidor", label: "Tipo Distribuidor", type: "select", options: [
                { value: "", label: "Selecione" },
                { value: 'AUTORIZADO', label: "Distribuidor Autorizado" },
                { value: 'LOGISTICO', label: "Distribuidor Logístico" },
                { value: 'TRANSPORTADOR', label: "York Transportadora" }
            ]
        },
        { name: "cnpj", label: "CNPJ", type: "input", colSpan: 1, icon: <FiHash className="text-muted-foreground" /> },
        { name: "codigoSap", label: "Código SAP", type: "input", colSpan: 1, icon: <FiHash className="text-muted-foreground" /> },
        { name: "codigoFortes", label: "Código Fortes", type: "input", colSpan: 1, icon: <FiHash className="text-muted-foreground" /> },
        { name: "codigoEmpresa", label: "Código Empresa", type: "input", colSpan: 1, icon: <FiHash className="text-muted-foreground" /> },
        { name: "codigoSolides", label: "Código Sólides", type: "input", colSpan: 1, icon: <FiHash className="text-muted-foreground" /> },
        { name: "codigoFornecedor", label: "Código de Fornecedor", type: "input", colSpan: 1, icon: <FiHash className="text-muted-foreground" /> },
        { name: "enderecoRua", label: "Endereço", type: "input", colSpan: 1, icon: <FiHash className="text-muted-foreground" /> },
        { name: "enderecoBairro", label: "Bairro", type: "input", colSpan: 1, icon: <FiHash className="text-muted-foreground" /> },
        {
            name: "enderecoCidadeId",
            label: "Cidade",
            type: "dropdown",
            options: cidades,
            optionLabel: "nome",
            optionValue: "id",
            colSpan: 1
        },
        {
            name: "enderecoEstadoId",
            label: "Estado",
            type: "dropdown",
            options: estados,
            optionLabel: "nome",
            optionValue: "id",
        },
        { name: "ativo", label: "Ativo", type: "booleanFooter" }
    ];

    const tableColumns = [
        { key: "id", label: "ID", bold: true },
        { key: "nome", label: "Nome" },
        { key: "codigo", label: "Cód Control" },
        { key: "tipoDistribuidor", label: "Tipo Distribuidor" },
        { key: "codigoSap", label: "Código SAP" },
        { key: "codigoFortes", label: "Código Fortes" },
        { key: "cnpj", label: "CNPJ" },
        { key: "ativo", label: "Ativo", render: v => v === false ? "Não" : "Sim" },
    ];

    return <CrudTemplate
        title="Gerenciar Filiais"
        formFields={formFields}
        tableColumns={tableColumns}
        service={service}
        style={{ width: '85%' }}
        modalHeader="Filial"
    />;
}
